<template>
  <div class="list-group mt-2">
    <button
      type="button"
      :class="`disable-cursor list-group-item list-group-item-action ${hover === documento.protocolo ? 'active' : ''}`"
      v-for="documento in documentos"
      :key="documento.protocolo"
      @mouseover="hover = documento.protocolo" @mouseleave="hover = ''"
    >
      <div class="row">
        <div v-if="hover === documento.protocolo" class="col-2 text-left">
          <span class="link" @click.prevent="abrirDocumento(documento.protocolo)" v-on:click="$emit('fechar-modal')">
            EDITAR
          </span>
        </div>
        <div :class="hover === documento.protocolo ? 'col-10' : 'col-8 text-left'">
          Criado por
          <br>
          <strong>{{ documento.autor.nome }}</strong>
          <br>
          Assunto
          <br>
          <strong>{{ documento.atributos.nomeAssunto }}</strong>
        </div>
        <div v-if="hover !== documento.protocolo" class="col-4 text-left">
          Data: <strong>{{ formatData(documento.dataCriacao) }}</strong>
          <br>
          País: <strong>{{ documento.atributos.pais }}</strong>
          <br>
          Estado: <strong>{{ documento.atributos.estado }}</strong>
          <br>
          Cidade: <strong>{{ documento.atributos.cidade }}</strong>
        </div>
      </div>
    </button>
  </div>
</template>

<script>
import VirtusService from '@/services/VirtusService'
import { localDateParse } from '@/uteis/converters/LocalDateConverter'

export default {
  props: {
    numeroProcesso: { type: String, required: true }
  },

  data () {
    return {
      hover: '',
      documentos: []
    }
  },

  methods: {
    buscarDocumentos () {
      this.service.documentoExterno(this.numeroProcesso, this.$store.getters.getDadosSessao.sessao.login).then(resp => {
        this.documentos = resp.data
        if (resp.data.length === 0) {
          this.abrirDocumento()
        }
      }).catch(err => {
        console.log(err)
      })
    },

    abrirDocumento (protocolo = '') {
      this.$router.push({ path: `/elaboracao/${this.numeroProcesso}/documento/${protocolo}` })
      this.$store.commit('MUT_DOCUMENTO', { numeroProtocolo: this.numeroProcesso, protocolo })
    },

    formatData (date) {
      return localDateParse(date).value
    }
  },

  created () {
    this.service = new VirtusService()
    this.buscarDocumentos()
  }
}
</script>
